/**
 * Objašnjenje oznake ponavljanja u tablici ("5d ×5").
 *
 * Sama oznaka je kratka da stane u redak, pa bez opisa ne govori ništa onome tko je ne
 * poznaje — tekst ide u tooltip na hover.
 */
export const getRepeatDescription = (
  intervalDays: number | null,
  count: number | null
): string => {
  const interval = intervalDays
    ? intervalDays === 1
      ? "svaki dan"
      : `svakih ${intervalDays} dana`
    : null;

  const total = count ? (count === 1 ? "jednom" : `${count} puta`) : null;

  if (interval && total) return `Ponavlja se ${interval}, ukupno ${total}.`;
  if (interval) return `Ponavlja se ${interval}.`;
  if (total) return `Ponavlja se ukupno ${total}.`;

  return "Ponavljanje je uključeno, ali interval i broj ponavljanja nisu zadani.";
};
